import { GlobalLayout } from "~/features/routing-guide/layout/global-layout.tsx";

export const RoutingGuideGlobalPage = () => <GlobalLayout />;
